import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter,RouterProvider} from 'react-router-dom';
import App from './App';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './styles.css';
const cachedTheme=localStorage.getItem('crm-theme');
document.documentElement.dataset.theme=cachedTheme==='dark'?'dark':'light';
const router=createBrowserRouter([{path:'*',element:<App/>}]);
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><RouterProvider router={router}/></React.StrictMode>);
